<div fxLayout="row">
  <div fxFlex><h2 mat-dialog-title>e-DMG</h2></div>
  <div fxFlex>
    <mat-form-field class="field-medium">
      <mat-label>Date</mat-label>
      <input matInput (dateChange)="getDmg($event.value)" [matDatepicker]="pickerDate">
      <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
      <mat-datepicker #pickerDate></mat-datepicker>
    </mat-form-field>  
  </div>
</div>
<mat-dialog-content>
  <form class="example-form">
    <div>
      <mat-form-field class="">
        <mat-label>Nom</mat-label>
        <input disabled="true" class="mat-input-disabled-enabled" type="text" [ngModel]="dmg.lastName" name="lastname" matInput placeholder="Nom de famille">
        <mat-hint class="hint-alert" *ngIf="dmg.lastName != patient.patient.getProperty('Lastname')">{{ patient.patient.getProperty('Lastname') }}</mat-hint>
      </mat-form-field>
      <mat-form-field class="">
        <mat-label>Prénom</mat-label>
        <input disabled="true" class="mat-input-disabled-enabled" type="text" [ngModel]="dmg.firstName" name="firstname" matInput placeholder="Prénom">
        <mat-hint class="hint-alert" *ngIf="dmg.firstName != patient.patient.getProperty('Firstname')">{{ patient.patient.getProperty('Firstname') }}</mat-hint>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="">
        <mat-label>Sexe</mat-label>
        <input disabled="true" class="mat-input-disabled-enabled" type="text" [ngModel]="dmg.sex" name="sex" matInput placeholder="Sexe">
        <mat-hint class="hint-alert" *ngIf="dmg.sex != patient.patient.getProperty('Sex')">{{ patient.patient.getProperty('Sex') }}</mat-hint>
      </mat-form-field>
      <mat-form-field class="">
        <mat-label>Date de naissance</mat-label>
        <input disabled="true" class="mat-input-disabled-enabled" type="text" [ngModel]="dmg.birthday" name="birthday" matInput placeholder="Date de naissance">
        <mat-hint class="hint-alert" *ngIf="dmg.birthday != patient.patient.getProperty('Birthday')">{{ patient.patient.getProperty('Birthday') }}</mat-hint>
      </mat-form-field>
    </div>
    <div *ngIf="hcparty" style="margin-top: 10px;">
      <h6>Détenteur du DMG</h6>
      <div>
        <mat-form-field class="">
          <mat-label>Nom</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="hcparty?.familyname" name="hcpartyfamilyname" matInput placeholder="Nom de famille">
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>Prénom</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="hcparty?.firstname" name="hcpartyfirstname" matInput placeholder="Prénom">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="">
          <mat-label>Spécialité</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="hcparty?.cds[0].value" name="hcpartyfcd" matInput placeholder="Nom de famille">
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>INAMI</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="hcparty?.ids[0].value" name="hcpartyid" matInput placeholder="Prénom">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="">
          <mat-label>Du</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="dmg.from" name="fromdate" matInput placeholder="Du">
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>Au</mat-label>
          <input type="text" class="mat-input-disabled-enabled" disabled="true" [ngModel]="dmg.to" name="todate" matInput placeholder="Au">
        </mat-form-field>
      </div>
      <div style="position:relative;">
        <mat-checkbox disabled="true" class="mat-input-disabled-enabled" style="float:left;" [ngModel]="dmg.payment" name="payment">DMG payé cette année ?</mat-checkbox>
        <div style="float:right;">
          <button mat-button class="btn btn-danger">Notification DMG</button>
        </div>
      </div>
    </div>
    <div *ngIf="!hcparty" style="margin-top: 10px;">
      <h6>Ce patient n'a pas de DMG, voulez-vous en créer un ?</h6>
      <div style="position:relative;">
        <button mat-button class="btn btn-danger">Notification DMG</button>
      </div>
    </div>
  </form>      
</mat-dialog-content>
